import { FaSeedling, FaSmile, FaCalendarCheck, FaGlobe } from 'react-icons/fa';

const counter = [
    { 
        id: 1,
        icon: <FaSeedling />, // Seedling icon for planting projects
        title: 'Planting Projects',
        count: '20000',
    },
    {
        id: 2,
        icon: <FaSmile />, // Smile icon for satisfied customers
        title: 'Satisfied Customers',
        count: '30000',
    },
    {
        id: 3,
        icon: <FaCalendarCheck />, // CalendarCheck icon for years of expertise
        title: 'Years of Expertise',
        count: '25',
    },
    {
        id: 4,
        icon: <FaGlobe />, // Globe icon for service regions
        title: 'Service Regions',
        count: '100',
    },
];

export default counter;